export const en = {
  title: "Text Case Manipulator",
  placeholder: "Enter your text here...",
  uppercase: "UPPERCASE",
  lowercase: "lowercase",
  titleCase: "Title Case",
  sentenceCase: "Sentence case",
  camelCase: "camelCase",
  snakeCase: "snake_case",
  reverseText: "Reverse Text",
  clearText: "Clear Text",
  copySuccess: "Text copied to clipboard!",
  copyError: "Error: No text to copy!",
  words: "Words",
  characters: "Characters",
  charactersNoSpaces: "Characters (no spaces)",
  copyButton: "Copy to clipboard",
  language: "Language",
  english: "English",
  vietnamese: "Vietnamese",
};
